import Vue from 'vue'
import axios from 'axios'
import { baseURL } from '../config'
// 获取仓库商品信息
export const storeList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 备注仓库商品信息
export const storeEditRemark = data => Vue.prototype.getAxios(baseURL + "/index.php", data)